module.exports = __webpack_public_path__ + "img/SKMJ_law2.cfa6d91c.png";